import { useCallback, useMemo } from 'react';
import { adminApi } from '../../services/adminApi';
import AdminGrid from './AdminGrid';

const fmtDate = (p) => p.value ? new Date(p.value).toLocaleDateString() : '-';

export default function OrgReportsTab({ orgId }) {
  const columns = useMemo(() => [
    { field: 'reportName', headerName: 'Report Name', minWidth: 180 },
    { field: 'reportType', headerName: 'Type' },
    { field: 'status', headerName: 'Status' },
    { field: 'companyName', headerName: 'Company', minWidth: 160 },
    { field: 'createdBy', headerName: 'Created By' },
    { field: 'createdAt', headerName: 'Created', valueFormatter: fmtDate },
    { field: 'lastRefreshed', headerName: 'Last Refreshed', valueFormatter: fmtDate },
  ], []);

  const fetchData = useCallback(async () => {
    const res = await adminApi.getOrgReports(orgId, { page: 0, size: 10000 });
    return res.content || [];
  }, [orgId]);

  return <AdminGrid columns={columns} fetchData={fetchData} />;
}
